import { UniButton } from '@/design-system/components/buttons';
import { H2, H6 } from '@/design-system/components/typography';
import { iframePostMessage } from '@/utils/iframePostMessage';
import { ScrollView, SxProp, View } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowDimensions } from 'react-native';
import { useStore } from 'store/store';
import SVGIconCustomerService from '../../../../assets/svg/CustomerService.svg';
import SuccessExchange from '../../../../assets/svg/SuccessExchange.svg';
import ExchangeImageBackground from '../background/exchange-image-background';
export interface InstructionSubmittedWebProps {}

const MAX_WIDTH_BODY = 750;
const MAX_WIDTH_BUTTON = 450;
const MIN_HEIGHT = 500;
export const InstructionSubmittedWebScreen: React.FC<InstructionSubmittedWebProps> = () => {
  const { width, height } = useWindowDimensions();
  const { container, body, title, intro, introQuestion, iconWrapper, button } = sxStyles;
  const store = useStore();
  const { t } = useTranslation('exchange-sub-account');
  const onBackToTrustOverview = () => {
    if (!!store.users?.metadata?.exchangeSubAccount && store.users.metadata.exchangeSubAccount.enabled) {
      iframePostMessage('backToExchangeOverview', true);
    } else {
      iframePostMessage('backToOverview', true);
    }
  };
  const renderChild = () => {
    return (
      <View
        sx={{
          ...body,
          ...{ width: width > MAX_WIDTH_BODY ? MAX_WIDTH_BODY : '100%' }
        }}>
        <SuccessExchange width={68} height={68} />
        <H2 sx={title} bold>
          {t('exchange-account::applied.title--application-instruction-submitted')}
        </H2>
        <H6 sx={intro} bold>
          {t('exchange-account::applied.text--get-in-touch-with-you')}
        </H6>
        <H6 sx={introQuestion} bold>
          {t('exchange-account::applied.text--customer-service-sub-1')}
          {'  '}
          <View sx={iconWrapper}>
            <SVGIconCustomerService width={'100%'} height={'100%'} />
          </View>
          {'  '}
          {t('exchange-account::applied.text--customer-service-sub-2')}
        </H6>

        <UniButton
          label={t('general::back-to-overview')}
          onPress={onBackToTrustOverview}
          sx={{
            ...button,
            ...{ width: width > MAX_WIDTH_BUTTON ? MAX_WIDTH_BUTTON : '100%' }
          }}
          size="medium"
        />
      </View>
    );
  };

  return (
    <View sx={container}>
      <ExchangeImageBackground />
      {height < MIN_HEIGHT ? <ScrollView showsVerticalScrollIndicator={false}>{renderChild()}</ScrollView> : renderChild()}
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    flex: 1,
    paddingX: '$4',
    backgroundColor: '$backgroundPrimary',
    justifyContent: 'center',
    alignItems: 'center'
  },
  body: {
    width: 750,
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    color: '$textTitle',
    mt: '$4',
    mb: '$5',
    mx: '$10',
    textAlign: 'center'
  },
  intro: {
    color: '$textDarkBackground',
    textAlign: 'center',
    flex: 1
  },
  introQuestion: {
    color: '$textDarkBackground',
    textAlign: 'center',
    alignContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    mt: '$5',
    flex: 1
  },
  iconWrapper: {
    width: 20,
    height: 20,
    transform: [{ scale: 1.4 }, { translateY: 3 }]
  },
  button: {
    width: 450,
    height: 56,
    mt: '$10'
  }
};
